<ion-content class="ion-padding">
  <div class="disclosure">
    <div class="icon-circle">
      <ion-icon name="location-outline" aria-hidden="true"></ion-icon>
    </div>

    <h1 class="disclosure__title">
      {{ 'movacarpro_location_disclosure_title' | translate }}
    </h1>

    <p class="disclosure__body">
      {{ 'movacarpro_location_disclosure_body' | translate }}
    </p>

    <ul class="info-list">
      <li class="info-row">
        <ion-icon name="navigate-outline" aria-hidden="true"></ion-icon>
        <span>{{ 'movacarpro_location_disclosure_point_tracking' | translate }}</span>
      </li>
      <li class="info-row">
        <ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>
        <span>{{ 'movacarpro_location_disclosure_point_protection' | translate }}</span>
      </li>
      <li class="info-row">
        <ion-icon name="lock-closed-outline" aria-hidden="true"></ion-icon>
        <span>{{ 'movacarpro_location_disclosure_point_privacy' | translate }}</span>
      </li>
    </ul>

    <div class="warning-box">
      <ion-icon name="warning-outline" aria-hidden="true"></ion-icon>
      <span>{{ 'movacarpro_location_disclosure_warning' | translate }}</span>
    </div>

    <ion-button expand="block" color="primary" (click)="accept()">
      {{ 'movacarpro_location_disclosure_accept' | translate }}
    </ion-button>

    <ion-button
      expand="block"
      fill="outline"
      color="medium"
      (click)="decline()"
    >
      {{ 'movacarpro_location_disclosure_decline' | translate }}
    </ion-button>

    <p class="disclosure__legal">
      {{ 'movacarpro_location_disclosure_legal_note' | translate }}
    </p>
  </div>
</ion-content>
